(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["usa-studio-short"] && !Shopify.designMode) return;
  try {
    (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const dataSaving = () => navigator.connection?.saveData === true;

    function initialize(root) {
      if (root.dataset.mxStudioInitialized === 'true') return;
      root.dataset.mxStudioInitialized = 'true';

      const video = root.querySelector('video');
      const button = root.querySelector('button');
      const sources = [...video.querySelectorAll('source[data-src]')];
      let observer;
      let inView = false;
      let userPaused = false;
      let hydrated = false;
      let failed = false;
      const hasObserver = 'IntersectionObserver' in window;

      const updateButton = () => {
        const playing = !video.paused && !video.ended;
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', playing ? root.dataset.pauseLabel : root.dataset.playLabel);
      };

      const pause = (showPoster = false) => {
        video.pause();
        if (showPoster) root.classList.remove('mx-studio-short--playing');
        updateButton();
      };

      const hydrate = () => {
        if (hydrated) return;
        sources.forEach((source) => { source.src = source.dataset.src; });
        hydrated = true;
        video.load();
      };

      const play = () => {
        if (failed || motion.matches || dataSaving() || document.hidden || !inView) return;
        hydrate();
        const pending = video.play();
        if (pending?.catch) pending.catch(() => { pause(true); });
      };

      const applyPreference = () => {
        if (failed || motion.matches || dataSaving()) {
          pause(true);
          root.classList.remove('mx-studio-short--enabled');
        } else {
          root.classList.add('mx-studio-short--enabled');
          if (hasObserver && inView && !userPaused) play();
        }
      };

      video.addEventListener('playing', () => {
        if (!motion.matches && !dataSaving() && inView && !document.hidden) {
          root.classList.add('mx-studio-short--playing');
        }
        updateButton();
      });
      video.addEventListener('pause', updateButton);
      const fail = () => {
        if (!hydrated) return;
        failed = true;
        pause(true);
        root.classList.remove('mx-studio-short--enabled');
      };
      video.addEventListener('error', fail);
      sources.forEach((source) => source.addEventListener('error', () => {
        if (!hydrated) return;
        source.dataset.mxStudioSourceFailed = 'true';
        const relevant = sources.filter((candidate) => !candidate.media || window.matchMedia(candidate.media).matches);
        if (video.readyState >= 2 && video.currentSrc) return;
        if (relevant.every((candidate) => candidate.dataset.mxStudioSourceFailed === 'true')) fail();
      }));
      button.addEventListener('click', () => {
        if (video.paused) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          pause();
        }
      });

      if (hasObserver) {
        observer = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          if (inView && !userPaused) play();
          if (!inView) pause();
        }, { threshold: 0.3 });
        observer.observe(root);
      } else {
        inView = true;
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) pause();
        else if (inView && !userPaused) play();
      });
      motion.addEventListener('change', applyPreference);
      applyPreference();
    }

    const initializeAll = () => document.querySelectorAll('[data-mx-studio-short]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
